import React from 'react';
import { Link } from 'react-router-dom';
import { Chrome, ArrowRight, ShieldCheck, Zap } from 'lucide-react';
import { Button } from '../../components/common';

export const HeroSection: React.FC = () => {
  return (
    <section className="relative overflow-hidden pt-16 pb-20 md:pt-24 md:pb-28 bg-gradient-to-b from-emerald-500/5 via-transparent to-transparent">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
        {/* Value pill */}
        <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-emerald-500/10 border border-emerald-500/20 text-emerald-700 dark:text-emerald-300 text-xs font-semibold mb-8 animate-in fade-in slide-in-from-bottom-3 duration-500">
          <Zap className="w-3.5 h-3.5 text-emerald-500 fill-emerald-500" />
          <span>Universal Multi-Tier E-Commerce Price Tracking</span>
        </div>

        {/* Hero title */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight text-slate-900 dark:text-slate-100 max-w-4xl mx-auto leading-tight sm:leading-none">
          Never Overpay. Track Prices with{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 via-teal-500 to-emerald-500 dark:from-emerald-400 dark:to-teal-300">
            Verified History.
          </span>
        </h1>

        {/* Subtitle */}
        <p className="mt-6 text-base sm:text-lg text-slate-600 dark:text-slate-400 max-w-2xl mx-auto leading-relaxed">
          Monitor product prices across any retailer. Inspect authentic historical price trends and receive instant alerts the moment verified prices drop.
        </p>

        {/* CTA buttons */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://chromewebstore.google.com"
            target="_blank"
            rel="noreferrer"
            className="w-full sm:w-auto"
          >
            <Button size="lg" variant="primary" className="w-full sm:w-auto gap-2 shadow-lg shadow-emerald-600/20">
              <Chrome className="w-5 h-5" />
              <span>Get Chrome Extension</span>
            </Button>
          </a>

          <Link to="/register" className="w-full sm:w-auto">
            <Button size="lg" variant="outline" className="w-full sm:w-auto gap-2">
              <span>Track on Web</span>
              <ArrowRight className="w-4 h-4" />
            </Button>
          </Link>
        </div>

        {/* Trust Badges */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-6 text-xs text-slate-500 dark:text-slate-400">
          <span className="flex items-center gap-1.5">
            <ShieldCheck className="w-4 h-4 text-emerald-500" />
            <span>Zero passive browsing tracking</span>
          </span>
          <span className="flex items-center gap-1.5">
            <ShieldCheck className="w-4 h-4 text-emerald-500" />
            <span>Free forever tier</span>
          </span>
          <span className="flex items-center gap-1.5">
            <ShieldCheck className="w-4 h-4 text-emerald-500" />
            <span>Works across Amazon, Noon, & 100+ stores</span>
          </span>
        </div>
      </div>
    </section>
  );
};
